import{css}from'glamor';import{themeConfig}from'@shopgate/pwa-common/helpers/config';export default css({color:themeConfig.colors.shade3}).toString();